<template>
	<section id="intro" class="intro">
		<!-- <img src="/images/sections/intro/intro-bg.jpg" alt="intro-bg" class="intro__bg" /> -->
		<video
			id="video-intro"
			ref="introVideo"
			playsinline
			src="https://dcdn.veonadx.com/landingveon/intro-bg3.mp4"
			data-src="https://dcdn.veonadx.com/landingveon/intro-bg3.mp4"
			loop
			muted
			autoplay
			poster="/images/sections/intro/videoframe_0.webp"
			class="intro__video">
			<track kind="captions" srclang="en" label="English captions" src="/captions/empty.vtt" />
		</video>
		<div class="intro__container container">
			<div class="intro__content">
				<h1 class="intro__title heading h1">
					{{ $t('pages.main.sections.intro.title') }}
				</h1>
				<p class="intro__subtitle">
					{{ $t('pages.main.sections.intro.subtitle') }}
				</p>
			</div>
			<NuxtLink to="#about" class="intro__scroll-btn">
				<span>{{ $t('basics.scrollDown') }}</span>
				<Icon name="local:arrow-anim" size="30" />
			</NuxtLink>
		</div>
		<div id="about-us"></div>
	</section>
</template>

<script setup lang="ts">
	const { $gsap: gsap } = useNuxtApp()

	const menuStore = useMenuStore()

	function introAnimation() {
		// gsap
		// 	.timeline({
		// 		scrollTrigger: {
		// 			trigger: '.intro',
		// 			start: 'top top',
		// 			// end: 'bottom+=200',
		// 			// start: 'top top',
		// 			// end: 'bottom top',
		// 			// end: 'bottom top',
		// 			scrub: true,
		// 			pin: true,
		// 			pinSpacing: false,
		// 		},
		// 	})
		// 	.to('.intro__video', {
		// 		yPercent: -20,
		//         // scale: 1.2,
		// 		ease: 'none',
		// 	})
		gsap
			.timeline({
				scrollTrigger: {
					trigger: '.intro',
					start: 'top top',
					scrub: true,
					// 			pin: true,
					// 			pinSpacing: false,
					onEnter: () => (menuStore.isScrolled = true),
					onLeaveBack: () => (menuStore.isScrolled = false),
				},
			})
			.to('.intro__video', {
				yPercent: 40,
				ease: 'none',
			})
	}

	const introVideo = ref<HTMLVideoElement | null>(null)

	onMounted(() => {
		introAnimation()
	})

	useVideoReady(
		'video-intro',
		() => {
			if (introVideo.value) {
				introVideo.value.play().catch((e) => {
					console.warn('Autoplay failed:', e)
				})
			}
		},
		introVideo
	)
</script>

<style scoped lang="scss">
	.intro {
		position: relative;
		display: flex;
		flex-direction: column;
		gap: 20px;

		// align-items: center;
		justify-content: center;
		width: 100%;
		min-height: 100svh;

		// background: url('@/assets/images/intro-bg.jpg') no-repeat center;
		// background-size: cover;
		padding: 50px 0;
		overflow: clip;
		color: var(--pure-white);
		background-color: var(--black);

		// background-color: #00000099;
		&__video {
			position: absolute;
			top: 0;
			left: 0;
			z-index: 0;
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
		&__content {
			position: relative;
			z-index: 1;
			display: flex;
			flex-direction: column;
			gap: 20px;

			// max-width: 60%;
			font-family: Montserrat, sans-serif;
		}
		&__title,
		&__subtitle {
			max-width: 70%;
			color: var(--primary);
			text-transform: uppercase;

			@media (width <= 767.98px) {
				max-width: 100%;
			}
		}
		&__subtitle {
			font-size: 24px;
			font-weight: bold;

			@media (width <= 767.98px) {
				font-size: 16px;
			}
		}
		&__scroll-btn {
			position: absolute;
			bottom: 16px;
			left: 50%;
			z-index: 1;
			display: flex;
			flex-direction: column;
			align-items: center;
			font-family: Montserrat, sans-serif;
			font-size: 12px;
			color: var(--white);
			text-transform: uppercase;
			transform: translateX(-50%);
		}

		// &__title {
		// 	font-size: 72px;
		// 	line-height: 1.2;
		// 	color: var(--primary);
		// 	text-transform: uppercase;
		// 	font-family: 'Montserrat', sans-serif;
		// }
		// &__subtitle {
		// 	font-size: 32px;
		// 	line-height: 1.2;
		// 	color: var(--primary);
		// 	text-transform: uppercase;
		// 	font-family: 'Montserrat', sans-serif;
		// }
	}
	#about-us {
		position: absolute;
		bottom: 0;

		// scroll-margin-top: 80px;
	}
</style>
